// src/services/dashboardService.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const dashboardService = createApi({
  reducerPath: "dashboardService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["dashboard"],
  endpoints: (builder) => ({
    getDashboardData: builder.mutation({
      query: (body) => ({
        url: `${userManagement.dashboardController.getDashboardData}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
      }),
    }),

    exportDashboardTables: builder.mutation({
      query: (body) => ({
        url: `${userManagement.dashboardController.exportTables}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "tables.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          return { success: true };
        },
      }),
    }),

    exportScriptureReferences: builder.mutation({
      query: (body) => ({
        url: `${userManagement.dashboardController.exportScriptureReferences}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "scripture_references.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          return { success: true };
        },
      }),
    }),

    exportFinancialStatements: builder.mutation({
      query: (body) => ({
        url: `${userManagement.dashboardController.exportFinancialStatements}`,
        method: "POST",
        headers: { Authorization: `Bearer ${body.token}` },
        body: body.payload,
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "financial_statements.xlsx";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          return { success: true };
        },
      }),
    }),
  }),
});

export const {
  useGetDashboardDataMutation,
  useExportDashboardTablesMutation,
  useExportScriptureReferencesMutation,
  useExportFinancialStatementsMutation,
} = dashboardService;
